module.exports = __webpack_public_path__ + "static/sf-products.4946f38e.png";